/* RESPONSIBLE TEAM: team-ml */
import StepSerializer from '../step';

export default StepSerializer.extend({
  attrs: {
    finOutputParams: { embedded: 'always' },
  },
});
